import React from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/** Reusable hero strip for inner pages. */
export const PageHero = ({ eyebrow, title, subtitle, breadcrumbs = [], children, className }) => {
  return (
    <section
      className={cn(
        'relative isolate overflow-hidden bg-gradient-hero text-primary-foreground',
        className,
      )}
      data-testid="page-hero"
    >
      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" />
      <div className="absolute -top-32 -right-24 h-72 w-72 rounded-full bg-accent/30 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-12 h-72 w-72 rounded-full bg-primary-glow/20 blur-3xl pointer-events-none" />

      <div className="container-app relative pt-14 pb-16 md:pt-20 md:pb-24">
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs/none mb-5 opacity-85" data-testid="page-breadcrumbs">
            <Link to="/" className="hover:underline">Home</Link>
            {breadcrumbs.map((b, idx) => (
              <React.Fragment key={idx}>
                <ChevronRight className="h-3 w-3 opacity-70" />
                {b.to ? (
                  <Link to={b.to} className="hover:underline">{b.label}</Link>
                ) : (
                  <span className="opacity-90">{b.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        {eyebrow && (
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] backdrop-blur">
            {eyebrow}
          </div>
        )}
        <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-balance max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-base sm:text-lg/relaxed opacity-90">{subtitle}</p>
        )}
        {children && <div className="mt-7">{children}</div>}
      </div>
    </section>
  );
};
